// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SESSION_ID } from '../../../../../config/session-id';
import { Captcha } from '../../../../components/captcha/captcha.model';

/** @ngInject */
export function Controller(
    $http,
    $scope,
    $state,
    BarcodeGeneratonService,
    SlackVerificationDataService,
) {

    $scope.displaySpinner = true;
    $scope.message = null;

    var INFO = "INFO";
    var ERROR = "ERROR";
    var SUCCESS = "SUCCESS";

    $scope.icon = INFO;
    $scope.showVerificationForm = true;  
    $scope.showIframe = false;

    const captcha = $scope.captcha = new Captcha({
        isVisible: () => $scope.attempts >= 5
    });
    
    // gets vkey attribute from query string
    $scope.vkey = $state.params.vkey;

    SlackVerificationDataService.get({
        vkey : $scope.vkey
    }, function(data) {
            $scope.displaySpinner = false;      
            // Show credentials page
            $scope.showVerificationForm = true;
            $scope.icon = INFO;          
            $scope.isSlack = true;
            $scope.message = "Activate SAASPASS Single Sign-on for Slack with your SAASPASS Mobile App";
            $scope.slackTeam = data.slackTeam;
            $scope.slackUsername = data.slackUsername;
            $scope.attempts = data.numberOfAttempts;
            $scope.showIframe = true;
    }, function(error) {
        // Error on verifying slack user. Do not show credentials page
        $scope.displaySpinner = false;
        $scope.icon = ERROR;       
        $scope.showVerificationForm = false;
        $scope.message = error.data.message;
        $scope.message2 = error.data.secondaryMessage;
        $scope.showIframe = false;
    });   

    $scope.verify = function() {
        $scope.trackerId = null;
        sendVerificationRequestWithCredentials();
        $('html, body').animate({ scrollTop:0 }, 'slow');
    };

    // e-mail after credentials are submited
    function sendVerificationRequestWithCredentials() {
        const url = 'app/rest/slackverificationdata/credentialcheck';
        var requestBody = {};
        requestBody.vkey = $scope.vkey;
        requestBody.saaspassId = $scope.username;
        requestBody.otp = $scope.password;     
        requestBody.trackerId = $scope.trackerId;     
        requestBody.captchaResponse = captcha.response;
        $scope.authenticationError = false;
        $scope.captchaError = false;
        $http.post(url, requestBody).then((response) => {
            const data = response.data;
            // Email verified
            $scope.icon = SUCCESS;
            $scope.message = data.message;
            $scope.message2 = data.secondaryMessage;
            $scope.showVerificationForm = false;
        }).catch((response) => {
            const data = response.data;
            if (data.incorrectCredentials) {
                // incorrect credentials
                $scope.attempts = data.numberOfAttempts;
                if (data.message == "Incorrect Captcha") {
                    $scope.captchaError = true;
                } else {
                    $scope.authenticationError = true;
                }

                return;
            }
            // Error on verifying slack user. Do not show credentials page
            $scope.icon = ERROR;
            $scope.showVerificationForm = false;
            $scope.message = data.message;
            $scope.message2 = data.secondaryMessage;
        })
        .finally(() => captcha.reset());
    }

    $scope.$on('websocket.LOGIN', (event, data) => {
        $scope.trackerId = data.password;
        $scope.username = data.username;
        $scope.password = null;
        sendVerificationRequestWithCredentials();
    });

    $scope.loadQrData = () => {
        return BarcodeGeneratonService
            .get({uuid: SESSION_ID}).$promise
            .then((barcode) => barcode.barcodeimage);
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/slack/slack-verification.controller.js